import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'

import Events from './events'
import Attachments from 'components/Attachments'
import Comments from 'components/Comments'
import Schedule from './Schedule'
import Price from './Price'

export default class RightSide extends Component{
	render(){
		let { props } = this
		let oneColumn = this.props.colspan == 1
		return(
			<div className="rightSide"
				style={{
					width: (this.props.colspan>1)?"50%":"100%"
				  , clear:"both"
					, paddingLeft:"5px"
				  , position: "relative"
				  , display: "block"
				  , overflowY: "hidden"
				  , paddingBottom: "50px"
				}}
			>
				<div className="wrapper"
					style={{
						paddingBottom: "70px"
					  , minHeight: !oneColumn?"calc(100vh - 64px)":"0"
					}}
				>
					<Attachments objectID={this.props.propertyID} removable={true}/>
					<Schedule propertyID={this.props.propertyID} />
					<Price propertyID={this.props.propertyID} />
				</div>


			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/RightSide.js